var isLength = {};
export {
  isLength as __exports
};
//# sourceMappingURL=isLength.js.map
